
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.219 5.781L16 14.562l8.781-8.781 1.438 1.438L17.438 16l8.781 8.781-1.438 1.438L16 17.438l-8.781 8.781-1.438-1.438L14.562 16 5.781 7.219z"}})])
          )
        }
      }
    